import React from "react";
import { Tooltip } from "antd";

export const EllipsisMiddle: React.FC<{
  suffixCount: number;
  children: string;
  className?: string;
  showTooltip?: boolean;
}> = ({ suffixCount = 10, children, className, showTooltip = true }) => {
  if (children.length <= suffixCount * 2) {
    return <span className={className}>{children}</span>;
  }

  const start = children.slice(0, suffixCount);
  const suffix = children.slice(-suffixCount);

  const content = (
    <span className={className}>
      {start}...{suffix}
    </span>
  );

  if (!showTooltip) {
    return content;
  }

  return (
    <Tooltip
      title={children}
      getPopupContainer={(triggerNode) => triggerNode}
      overlayStyle={{
        maxWidth: 500,
        whiteSpace: "pre-wrap",
      }}
    >
      {content}
    </Tooltip>
  );
};
